import { render } from "./LoaderComponent.vue?vue&type=template&id=6feed2b6"
import script from "./LoaderComponent.vue?vue&type=script&lang=js"
export * from "./LoaderComponent.vue?vue&type=script&lang=js"

import "./LoaderComponent.vue?vue&type=style&index=0&id=6feed2b6&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__